var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.41 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #afb1b3;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.41,17.67c-.03.29-.05.59-.09.88-.07.46-.15.91-.24,1.36,0,.04-.07.09-.11.09-1.18,0-2.37,0-3.55,0,0,0,0,0-.03-.02.03-.23.07-.47.1-.7.15-1.09.25-2.19.18-3.3-.08-1.25-.46-2.42-1.05-3.52-1.1-2.05-2.7-3.56-4.79-4.57-.68-.33-1.4-.55-2.14-.67-.03,0-.06,0-.1,0,0,.07,0,.13,0,.19,0,3.05,0,6.1.01,9.15,0,.13-.04.19-.15.25-1.15.55-2.29,1.11-3.44,1.66-.04.02-.08.04-.14.06V7.17c-.27.05-.52.09-.77.15-1.87.45-3.45,1.43-4.78,2.8-1.28,1.31-2.13,2.86-2.47,4.67-.16.86-.21,1.73-.17,2.6.04.84.12,1.67.18,2.5,0,.03,0,.07,0,.1H.12c-.03-.39-.07-.77-.08-1.15-.02-.77-.05-1.54-.03-2.31.09-2.96.94-5.66,2.8-8,1.68-2.12,3.83-3.55,6.38-4.42.83-.28,1.68-.49,2.54-.62.11-.02.14-.05.14-.16,0-.49,0-.98,0-1.47,0-.08.01-.13.09-.17,1.04-.51,2.08-1.02,3.12-1.53.13-.07.28-.11.42-.16.03,0,.06,0,.09,0,0,.05,0,.09,0,.14.01.76.03,1.51.04,2.27,0,.35,0,.69,0,1.04.17.03.31.07.45.09,1.36.19,2.62.65,3.82,1.3,2.43,1.33,4.36,3.16,5.73,5.58.97,1.71,1.56,3.55,1.74,5.51.02.17.04.34.05.51v1.23Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManat);
export default __webpack_public_path__ + "static/media/manat.26164df82fe5e01dc204bc09d23e9043.svg";
export { ForwardRef as ReactComponent };